import { useSupabaseLoader } from "../../../server/supabase/hooks";

interface SentMomentCounts {
  sent: number;
  active: number;
}

export function useSentMomentCounts(): ReturnType<typeof useSupabaseLoader<SentMomentCounts>> {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    const countSent = () =>
      supabase
        .from("moments_sent")
        .select("id", { count: "exact", head: true })
        .eq("account_id", account_id);

    const [sent, active] = await Promise.all([countSent(), countSent().eq("status", "active")]);
    if (sent.error) throw sent.error;
    if (active.error) throw active.error;

    return { sent: sent.count ?? 0, active: active.count ?? 0 };
  }, []);
}
